export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7077.87c9441a.jpg";